import { render, staticRenderFns } from "./Accordion-Item.vue?vue&type=template&id=5fe0a470&"
import script from "./Accordion-Item.vue?vue&type=script&lang=js&"
export * from "./Accordion-Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports